
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// --- 1. Dynamic Material Card Component ---
const MaterialCard = ({ data, type }) => {
    const isSource = type === 'source';
    const material = data || {}; // Safety check

    return (
        <div className={`material-card ${isSource ? 'source-material' : 'target-material'}`}>
            {/* Badge Section */}
            <div className={`material-badge ${isSource ? 'source-badge' : 'target-badge'}`}>
                {isSource ? (
                    <span className="badge-dot"></span>
                ) : (
                    <CheckCircleIcon className="badge-icon" />
                )}
                {isSource ? 'Replacing' : 'New Material'}
            </div>

            {/* Title */}
            <div className="material-name">{material.item}</div>

            {/* Details Grid */}
            <div className="material-details">
                <div className="detail-item">
                    <span className="detail-label">Part No:</span>
                    <span className="detail-value part-no">{material.part_no || 'N/A'}</span>
                </div>

                <div className="detail-item">
                    <span className="detail-label">Manufacturer:</span>
                    <span className="detail-value">{material.manufacturer || 'N/A'}</span>
                </div>

                <div className="detail-item">
                    <span className="detail-label">Unit Cost:</span>
                    <span className="detail-value">${material.cost ?? 'N/A'}/{material.unit || 'N/A'}</span>
                </div>

                <div className="detail-item">
                    <span className="category-badge">{material.category_name || 'N/A'}</span>
                </div>
            </div>
        </div>
    );
};

export default MaterialCard;